import axios from 'axios'
import { API_URL, getAuthHeader } from '@/services/api.service.js'
import { logger } from '@/utils/logger'

/**
 * Fetch last states of each type for a board
 */
export const fetchLastStates = async ({ boardId, processId = null }) => {
  try {
    const ret = await axios.get(`${await API_URL()}/states/${boardId}/${processId}`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data
    } else {
      return null
    }
  } catch (error) {
    logger.info(error.message)
    return null
  }
}
